import { createRoot } from "react-dom/client";
import App from "./App";
import { ErrorBoundary } from "./components/error-boundary";
import "./index.css";

// Initialize performance monitoring (auto-installs if enabled)
import "./services/performance-monitor";

// Always-on client error reporting (task #1)
import { installErrorReporter } from "./services/error-reporter";
installErrorReporter();

// Hand over anything the user already typed into the static pre-mount login
// shell (see client/index.html) before React wipes it from the DOM.
try {
  const bootEmail = document.getElementById("boot-email") as HTMLInputElement | null;
  const bootPassword = document.getElementById("boot-password") as HTMLInputElement | null;
  if (bootEmail || bootPassword) {
    const active = document.activeElement?.id;
    (window as any).__bootLogin = {
      email: bootEmail?.value ?? "",
      password: bootPassword?.value ?? "",
      focus: active === "boot-email" ? "email" : active === "boot-password" ? "password" : null,
    };
  }
} catch {}

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
